<template>
  <div class="page-webinar">
    <header>
      <h1 v-if="page.image">
        <figure>
          <nuxt-img
            :src="page.image.src"
            :alt="page.name"
            :height="page.image.height"
            :width="page.image.width"
          />
        </figure>
      </h1>

      <div v-else class="columns small-12 medium-12">
        <h1>
          {{ page.name }}
        </h1>
        <div v-if="page.description" class="text-big" v-html="page.description"></div>

        <p v-if="page.cta">
          <a :href="page.cta.url" title="Go to page" class="button button-primary">
            {{ page.cta.title }}
          </a>
        </p>
      </div>
    </header>

    <section
      v-for="(section, index) in page.sections"
      :key="section.id"
      :class="[
        'section',
        'section-' + section.type,
        'section-' + section.color,
        isLast(page.sections.length, index),
      ]"
    >
      <div v-if="section.type === 'block'" class="row align-center align-middle">
        <div v-if="section.image" class="columns small-12 medium-2 large-4">
          <figure>
            <nuxt-img
              v-if="section.image"
              :src="section.image.src"
              :alt="section.alt"
              :height="section.image.height"
              :width="section.image.width"
              style="margin: 0 auto"
            />
          </figure>
        </div>

        <div class="columns small-12 medium-10 large-8">
          <h2 v-if="section.title" class="text-center">{{ section.title }}</h2>
          <span v-if="section.description" v-html="section.description"></span>

          <p v-if="section.cta" class="text-center">
            <a :href="section.cta.url" title="" class="button button-primary">
              {{ section.cta.title }}
            </a>
          </p>
        </div>
      </div>
      <div v-if="section.type === 'list'" class="row align-center align-middle">
        <ul class="row block-grid small-up-2 large-up-4">
          <li v-for="item in section.items" :key="item.title" class="flex align-middle">
            <nuxt-img :src="item.image" alt="" width="100" height="100" />
            <div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </li>
        </ul>

        <p v-if="section.cta">
          <a :href="section.cta.url" title="" class="button button-primary">
            {{ section.cta.title }}
          </a>
        </p>
      </div>
      <div v-if="section.type === 'columns'">
        <template v-if="section.title">
          <h2 class="text-center">{{ section.title }}</h2>
          <br />
        </template>
        <div class="row">
          <div class="columns small-12 medium-6 large-6">
            <span v-html="section.column_1"></span>
          </div>

          <div class="columns small-12 medium-6 large-6">
            <span v-html="section.column_2"></span>

            <form
              v-if="section.register_form"
              id="registration-form"
              ref="registration-form"
              action="/fn/webinar"
              method="POST"
            >
              <h3>Register for this webinar</h3>
              <p>
                Add your details below to register. We'll send you an email with the link to join.
              </p>
              <div class="form-group">
                <label for="first_name">
                  First Name
                  <sup>*</sup>
                </label>
                <input
                  id="first_name"
                  v-model="first_name"
                  type="text"
                  name="first_name"
                  class="form-control"
                  required=""
                />
              </div>
              <div class="form-group">
                <label for="last_name">
                  Last Name
                  <sup>*</sup>
                </label>
                <input
                  id="last_name"
                  v-model="last_name"
                  type="text"
                  name="last_name"
                  class="form-control"
                  required=""
                />
              </div>
              <div class="form-group">
                <label for="email">
                  Email
                  <sup>*</sup>
                </label>
                <input
                  id="email"
                  v-model="email"
                  type="email"
                  name="email"
                  class="form-control"
                  required=""
                />
              </div>
              <div>
                <label for="newsletter_subscription">
                  <input
                    id="newsletter_subscription"
                    v-model="newsletter_subscription"
                    type="checkbox"
                    value="yes"
                    name="newsletter_subscription"
                    class="form-control"
                  />
                  &nbsp;&nbsp;Please email me with webinar invitations, the latest resources &
                  teaching inspiration.
                </label>
              </div>

              <input
                type="hidden"
                name="session_id"
                value="4cebbe05-90d6-43fa-840e-9ee987510a05"
                class="form-control"
              />
              <input
                type="hidden"
                name="referrer"
                :value="section.session_name"
                class="form-control"
              />
              <input
                type="hidden"
                name="utm_source"
                :value="$route.query.utm_source"
                class="form-control"
              />
              <input
                type="hidden"
                name="utm_campaign"
                :value="$route.query.utm_campaign"
                class="form-control"
              />
              <input
                type="hidden"
                name="utm_medium"
                :value="$route.query.utm_medium"
                class="form-control"
              />
              <input
                type="hidden"
                name="registration_url"
                :value="section.registration_url"
                class="form-control"
              />
              <recaptcha :error="formerror" />
              <button
                id="webinar-submit"
                type="submit"
                class="button button-primary"
                @click="onSubmit"
              >
                Register
              </button>
            </form>
          </div>
        </div>
      </div>
      <div v-if="section.speakers" class="row">
        <div class="columns small-12 medium-12 large-4">
          <span v-html="section.speaker_1"></span>
        </div>
        <div class="columns small-12 medium-12 large-4">
          <span v-html="section.speaker_2"></span>
        </div>
        <div class="columns small-12 medium-12 large-4">
          <span v-html="section.speaker_3"></span>
        </div>
      </div>

      <div v-if="section.webinar_footer" class="row">
        <div class="columns small-12 medium-6 large-6">
          <span v-html="section.speaker_1"></span>
        </div>
        <div class="columns small-12 medium-6 large-6">
          <span v-html="section.speaker_2"></span>
        </div>
      </div>

      <div v-if="section.type === 'resources'" class="section row">
        <h2 v-if="section.title">{{ section.title }}</h2>
        <span v-if="section.description" v-html="section.description"></span>
        <div>
          <resources-list v-if="section.resource_params" :params="section.resource_params" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* Webinar page template
 * Add your content as JSON files in /data/webinar
 */
import ResourcesList from '~/components/resource/ResourcesList.vue';
import Recaptcha from '~/components/Recaptcha.vue';

export default {
  name: 'WebinarResource',
  components: {
    ResourcesList,
    Recaptcha,
  },
  async asyncData({ app, params, route, error }) {
    const data = { page: null, errorBlogs: null };

    try {
      // Load page content from a JSON file - only works with asyncData, not fetch

      const page = await import('@/data/webinar/' + params.slug + '.json');

      if (page) {
        data.page = page;
        data.title = data.page.name;
        data.description = data.page.meta_description;

        data.page.event_params = app.$constructEventParamsPage(page);
      }
      return data;
    } catch (err) {
      // No JSON file matching the route
      error({ statusCode: 404, message: err.message, path: route.path });
    }
  },
  data() {
    return {
      title: 'Webinar',
      description: '',
      first_name: '',
      last_name: '',
      email: '',
      event_params: {},
      registration_url: '',
      newsletter_subscription: '',
      formerror: false,
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  methods: {
    calcCols(count) {
      if (count > 3) {
        return count / 2;
      }
      return count;
    },
    isLast(length, index) {
      // Apply a class to the last section to remove the bottom margin
      return length - 1 === index ? 'is-last' : '';
    },
    onSubmit(e) {
      const token = document.querySelector('#g-recaptcha-response');
      if (!token || !token.value) {
        this.formerror = true;
        console.error('Missing recaptcha token');
        e.preventDefault();
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* Sections */

h1 {
  figure {
    margin-top: -$base-padding * 2;
  }
}

header {
  img {
    margin: 0 auto;
    max-width: 1024px;
    width: 100%;
  }
}

.section-list {
  img {
    height: auto;
    margin-right: $base-padding-half;
  }

  h3,
  p {
    margin: 0;
  }
}

@media #{$medium-up} {
  .medium-12 {
    margin-top: 2rem;
  }
}
</style>
